module.exports = __webpack_public_path__ + "static/assets/can.29f8c1fd.jpg";